export const FETCH_PRICING_RULES_QUERY = "fetchPricingRules";
export const FETCH_SQUARE_LOCATIONS_QUERY = "fetchSquareLocation";
export const FETCH_SETTINGS_QUERY = "fetchSettings";
export const FETCH_DROPSHIPPER_DATA_QUERY = "fetchDropshipperData";
export const FETCH_ADDRESS = "fetchAddressData";
